import React from 'react';
import './author-dashboard-metrics-type-bar.scss';

const AuthorDashboardMetricsTypeBar = ({progress}) => {
  return (
    <div className='author-dashboard-metrics__type-wrapper'>
      <div className='author-dashboard-metrics__type-filler' style={{width: `${progress}%`}} />
    </div>
  );
};

export default AuthorDashboardMetricsTypeBar;
